import React, { useState, ReactElement, useEffect } from "react";

interface ExpandableProps {
  children: React.ReactNode;
  className?: string;
  collapsedWidth?: number;
  expandedWidth?: number;
  keepExpanded?: boolean;
  expandFull?: boolean;
  triggerWith?: "hover" | "click";
}

const ExpandableContainer: React.FC<ExpandableProps> = ({
  children,
  className,
  collapsedWidth = 64,
  expandedWidth = 284,
  keepExpanded = false,
  expandFull = false,
  triggerWith = "hover",
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const shouldExpand = isExpanded || keepExpanded;

  const handleMouseEnter = () => {
    if (triggerWith === "hover") setIsExpanded(true);
  };
  const handleMouseLeave = () => {
    if (triggerWith === "hover") setIsExpanded(false);
  };
  const handleClick = () => {
    if (triggerWith === "click") setIsExpanded(!isExpanded);
  };

  const getContainerWidth = () => {
    if (expandFull) return "100vw";

    return `${shouldExpand ? expandedWidth : collapsedWidth}px`;
  };

  const width = getContainerWidth();

  const enhancedChildren = React.Children.map(children, (child) => {
    // Ensure the child is a valid element before cloning
    if (React.isValidElement(child)) {
      return React.cloneElement(
        child as ReactElement,
        {
          isExpanded: shouldExpand,
        } as any
      );
    }
    return child;
  });

  return (
    <div
      className={`${className} transition-all duration-300 ease-in-out`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
      style={{
        width,
        transition: "width 300ms ease-in-out",
      }}
    >
      {enhancedChildren}
    </div>
  );
};

export default ExpandableContainer;
